import { RouteRecordRaw } from "vue-router";
import BasicLayout from "@/layouts/BasicLayout.vue";

const page = (path: string) => () => import(`@/views/${path}.vue`);

export const routes: Array<RouteRecordRaw> = [
  {
    path: "/",
    name: "layout",
    component: BasicLayout,
    children: [
      { path: "", redirect: "/problems" },
      {
        path: "problems",
        name: "problemList",
        component: page("problem/ProblemListView"),
        meta: { title: "Problems", menuKey: "/problems" },
      },
      {
        path: "problems/:id/submit",
        name: "problemSubmit",
        component: page("problem/ProblemSubmitView"),
        meta: { title: "Submit", menuKey: "/problems" },
      },
      {
        path: "posts",
        name: "postList",
        component: page("post/PostListView"),
        meta: { title: "Posts", menuKey: "/posts" },
      },
      {
        path: "posts/create",
        name: "postCreate",
        component: page("post/PostEditView"),
        meta: { title: "Create Post", menuKey: "/posts", requiresAuth: true },
      },
      {
        path: "posts/:id",
        name: "postDetail",
        component: page("post/PostDetailView"),
        meta: { title: "Post Detail", menuKey: "/posts" },
      },
      {
        path: "posts/:id/edit",
        name: "postEdit",
        component: page("post/PostEditView"),
        meta: { title: "Edit Post", menuKey: "/posts", requiresAuth: true },
      },
      {
        path: "submissions/my",
        name: "mySubmissions",
        component: page("submission/MySubmissionView"),
        meta: {
          title: "My Submissions",
          menuKey: "/submissions/my",
          requiresAuth: true,
        },
      },
      {
        path: "user/profile",
        name: "userProfile",
        component: page("user/UserProfileView"),
        meta: {
          title: "Profile",
          menuKey: "/user/profile",
          requiresAuth: true,
        },
      },
      {
        path: "notifications",
        name: "notifications",
        component: page("notification/NotificationView"),
        meta: {
          title: "Notifications",
          menuKey: "/notifications",
          requiresAuth: true,
        },
      },
      {
        path: "reports/my",
        name: "myReports",
        component: page("report/ReportListView"),
        meta: {
          title: "My Reports",
          menuKey: "/reports/my",
          requiresAuth: true,
        },
      },
      {
        path: "user/space",
        name: "mySpace",
        component: page("user/MySpaceView"),
        meta: { title: "My Space", menuKey: "/user/space", requiresAuth: true },
      },
      { path: "ranking", name: "ranking", redirect: "/score/stats" },
      {
        path: "wrong-problems",
        name: "wrongProblems",
        redirect: "/user/space",
        meta: {
          title: "Wrong Problems",
          menuKey: "/user/space",
          requiresAuth: true,
        },
      },
      {
        path: "score/records",
        name: "scoreRecords",
        component: page("score/ScoreRecordView"),
        meta: {
          title: "Score Records",
          menuKey: "/score/records",
          requiresAuth: true,
        },
      },
      {
        path: "score/stats",
        name: "scoreStats",
        component: page("ranking/RankingView"),
        meta: { title: "Ranking", menuKey: "/score/stats" },
      },
      {
        path: "admin",
        name: "adminDashboard",
        component: page("admin/AdminDashboardView"),
        meta: {
          title: "Admin",
          menuKey: "/admin",
          requiresAuth: true,
          requiresAdmin: true,
        },
      },
      {
        path: "admin/users",
        name: "adminUsers",
        component: page("admin/AdminUserView"),
        meta: {
          title: "User Admin",
          menuKey: "/admin/users",
          requiresAuth: true,
          requiresAdmin: true,
        },
      },
      {
        path: "admin/problems",
        name: "adminProblems",
        component: page("admin/AdminProblemView"),
        meta: {
          title: "Problem Admin",
          menuKey: "/admin/problems",
          requiresAuth: true,
          requiresAdmin: true,
        },
      },
      {
        path: "admin/submissions",
        name: "adminSubmissions",
        component: page("admin/AdminSubmissionView"),
        meta: {
          title: "Submission Admin",
          menuKey: "/admin/submissions",
          requiresAuth: true,
          requiresAdmin: true,
        },
      },
      {
        path: "admin/posts",
        name: "adminPosts",
        component: page("admin/AdminPostReviewView"),
        meta: {
          title: "Post Review",
          menuKey: "/admin/posts",
          requiresAuth: true,
          requiresAdmin: true,
        },
      },
      {
        path: "admin/comments",
        name: "adminComments",
        component: page("admin/AdminCommentReviewView"),
        meta: {
          title: "Comment Review",
          menuKey: "/admin/comments",
          requiresAuth: true,
          requiresAdmin: true,
        },
      },
      {
        path: "admin/post-comments",
        name: "adminPostComments",
        component: page("admin/AdminPostCommentReviewView"),
        meta: {
          title: "Post Comment Review",
          menuKey: "/admin/post-comments",
          requiresAuth: true,
          requiresAdmin: true,
        },
      },
      {
        path: "admin/post-categories",
        name: "adminPostCategories",
        component: page("admin/AdminPostCategoryView"),
        meta: {
          title: "Post Categories",
          menuKey: "/admin/post-categories",
          requiresAuth: true,
          requiresAdmin: true,
        },
      },
      {
        path: "admin/reports",
        name: "adminReports",
        component: page("report/ReportListView"),
        meta: {
          title: "Reports",
          menuKey: "/admin/reports",
          requiresAuth: true,
          requiresAdmin: true,
        },
      },
    ],
  },
  {
    path: "/user/login",
    name: "login",
    component: page("user/LoginView"),
    meta: { title: "Login", publicOnly: true },
  },
  {
    path: "/user/register",
    name: "register",
    redirect: { name: "login" },
  },
  {
    path: "/403",
    name: "forbidden",
    component: page("error/ForbiddenView"),
    meta: { title: "Forbidden" },
  },
  {
    path: "/:pathMatch(.*)*",
    name: "notFound",
    component: page("error/NotFoundView"),
    meta: { title: "Not Found" },
  },
];
